import { PhoneIcon } from '../../base'

function Call({ number, show = true, color = 'pcolor' }) {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    return (
        <div className='d-flex contactOption gap-1' style={{alignItems : 'center'}}>
            <PhoneIcon /> :
            {
                isMobile ?
                    <a className={`h6 option ms-2 ${color}`} href={`tel:${number}`}>{number} {show && <span className='ms-2 h7' style={{textDecoration : 'none'}}>( click to call )</span> }</a> :
                    <div className={`h6 option ms-2 ${color}`}>{number} {show && <span className='h7'>( call us directly )</span>}</div>
            }
        </div>
    )
}

export default Call